import { IFieldValidator,  } from 'src/app/interfaces/field-settings.interface';
import { IFieldValidationParams } from 'src/app/interfaces/zc-validation-result.interface';
type CustomValidatorFunction = (params: IFieldValidationParams) => boolean;

export class CustomFieldValidator implements IFieldValidator {
    private isValid: CustomValidatorFunction;
    private errorMessage = 'Validation error';

    constructor(errorMessage: string, validationCondition: CustomValidatorFunction) {
        this.isValid = validationCondition;
        this.errorMessage = errorMessage;
    }

    validate(params: IFieldValidationParams): string {
        if (this.isValid(params)) {
            return null;
        }

        return this.errorMessage;
    }
}
